import axios from 'axios'
import constants, {CONTEXT} from './helpers/constants'
import Vue from 'vue'
import global_vars from "./helpers/global_vars";

axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]')?.content;

Vue.prototype.$constants = constants
Vue.prototype.$context = CONTEXT
Vue.prototype.$global_vars = global_vars

// layouts
Vue.component('page-builder-layout', require('./components/layouts/PageBuilderLayout').default);
// Vue.component('careers-page-layout', require('./components/layouts/CareersPageLayout').default);
// Vue.component('job-page-layout', require('./components/layouts/JobPageLayout').default);
Vue.component('category-page-layout', require('./components/layouts/CategoryPageLayout').default);
Vue.component('not-found-layout', require('./components/layouts/NotFoundLayout').default);

// builder list
let req = require.context('./components/builder_components', true, /\.(js|vue)$/i);
req.keys().forEach(key => {
  let name = key.match(/\w+/)[0];
  let component_name = name.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`).replace('-', '')
  Vue.component(component_name, require(`./components/builder_components/${name}`).default)
});

export default Vue;
